var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.classes},[_vm._v("pt-gene-report-apply-list")])}
var staticRenderFns = []

export { render, staticRenderFns }